<template>
  <div class="wallet-page">
    <v-header>我的錢包</v-header>
    <div class="wallet-page_content">
      <user-content
        class="wallet-page_header"
        :show-avatar="false"
        :user-name="userInfo.LOGIN_ACCOUNT"
      >
        <span></span>
      </user-content>
      <div class="wallet-page_detail j-store-currency-dcount-container">
        <div class="wallet-page_detail--header">
          <div class="wallet-page_detail--title">錢包餘額：</div>
          <div class="wallet-page_detail--tips">
            <i class="warning-icon"></i>1TWD=10G幣
          </div>
        </div>
        <div class="wallet-page_detail--msg">
          <div class="wallet-page_detail--overage">
            <span class="platform-number spec">{{ overageNum }}</span>
            G幣
          </div>
          <div
            class="wallet-page_detail--store j-store-currency-dcount"
            @click="jumpToStore"
          >
            餘額充值
          </div>
        </div>
        <i class="wallet-page_detail--line"></i>
        <div class="wallet-page_detail--coupon" @click="jumpToCoupon">
          <span class="wallet-page_detail--coupon-title">我的抵扣券</span>
          <span
            class="wallet-page_detail--coupon-number"
            :class="[showNew ? 'new' : false]"
          >
            <span class="spec-number">{{ couponNumber }}</span
            >張
            <i class="spec-more" v-if="showNew"></i>
          </span>
        </div>
      </div>
      <div class="wallet-page_ad" v-if="adList.length">
        <swiper :options="swiperOption">
          <swiper-slide v-for="item in adList" :key="item.name">
            <img
              style="border-radius: 10px"
              width="100%"
              height="100%"
              @click="adJump(item.AD_URL)"
              :src="item.AD_PIC"
              alt="ad_pic"
            />
            <span class="wallet-page_ad-title">{{ item.AD_TITLE }}</span>
          </swiper-slide>
          <template #pagination>
            <div class="swiper-pagination"></div>
          </template>
        </swiper>
      </div>
      <div class="wallet-page_rules">
        <h4 class="wallet-page_rules--title">G幣使用說明：</h4>
        <p class="wallet-page_rules--text">
          1.
          在G妹平台儲值中心中，購買道具所剩餘的金額統一按兌換比例自動轉入我的我的錢包；
        </p>
        <p class="wallet-page_rules--text">
          2.
          G幣僅能兌換遊戲的商品與服務，不能兌換現金，不能進行轉帳交易，不可以兌換其他遊戲產品內容；
        </p>
        <p class="wallet-page_rules--text">
          3. G幣可以在G妹平台儲值中進行兌換；
        </p>
        <p class="wallet-page_rules--text">
          4. G幣為虛擬物品，兌換後除非異常問題，否則無法進行退款返還操作。
        </p>
      </div>
      <common-footer class="wallet-footer"></common-footer>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import vHeader from '@/components/header'
import userContent from '@/components/user-info'
import commonFooter from '@/components/common-footer'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'WalletPage',
  components: {
    vHeader,
    userContent,
    commonFooter,
    swiper,
    swiperSlide
  },
  data () {
    return {
      overageNum: 0,
      adList: [],
      portraitList: [],
      landscapeList: [],
      couponNumber: 0,
      showNew: false,
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 3000
        }
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.getUserInfo
    },
    isPortrait () {
      return this.$store.getters.getDeviceDirection
    }
  },
  watch: {
    isPortrait (val) {
      this.adList = val ? this.portraitList : this.landscapeList
    }
  },
  methods: {
    adJump (url) {
      this.$datain({ ext3: '轮播图-按钮' })
      if (!url) return
      window.location.href = url
    },
    jumpToCoupon () {
      window.localStorage.setItem('CLICK_TIME', Date.now())
      this.$datain({ ext3: '查看抵扣券-按钮' })
      this.$router.push({ name: 'coupon' })
    },
    jumpToStore () {
      this.$datain({ ext3: '餘額储值-按钮' })
      this.$router.push({ name: 'store' })
    },
    jumpToGame () {
      this.$router.push({ name: 'game' })
    },
    initCouponList (data) {
      function formatTimeText (str) {
        if (str.startsWith('9999')) {
          return '無限期'
        }
        let index = str.indexOf(' ')
        return str.substr(0, index).replace(/-/gi, '.')
      }
      return data.map((coupon) => {
        coupon.id = coupon.ID
        coupon.name = `${coupon.REDUCTION}G幣`
        coupon.value = +coupon.REDUCTION
        coupon.type = +coupon.EXPIRY ? 'G幣抵扣券已過期' : 'G幣抵扣券'
        coupon.timeText = `${formatTimeText(
          coupon.START_TIME
        )}-${formatTimeText(coupon.EXPIRY_TIME)}`
        if (+coupon.EXPIRY) {
          coupon.couponClass = 'coupon-expired'
        } else {
          let couponClass = [1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000]
          let index = couponClass.findIndex((item) => coupon.value <= item)
          if (coupon.value > 8000) {
            index = couponClass.length - 1
          }
          coupon.couponClass = `coupon-${couponClass[index]}`
        }
        return coupon
      })
    },
    initData (data) {
      this.user = data.user_info
      let obj = Object.assign({}, data.user_info, this.userInfo)
      this.$store.commit('setUserInfo', obj)
      this.overageNum = this.user.POINTS
      this.portraitList = data.ads
      this.landscapeList = data.ads.map((item) => {
        return {
          AD_PIC: item.AD_PIC_LAND,
          AD_TITLE: item.AD_TITLE,
          AD_URL: item.AD_URL
        }
      })
      this.adList = this.isPortrait ? this.portraitList : this.landscapeList
      if (data.coupons.normal.length) {
        let lastGetTime = data.coupons.normal.sort(
          (a, b) => b.GET_TIME - a.GET_TIME
        )[0]
        lastGetTime = lastGetTime ? lastGetTime.GET_TIME : ''
        lastGetTime = lastGetTime
          ? Date.parse(lastGetTime.replace(/-/g, '/'))
          : 0
        let clickTime = window.localStorage.getItem('CLICK_TIME') || 0
        if (clickTime > lastGetTime) {
          this.showNew = false
        } else {
          this.showNew = true
        }
      }
      this.couponNumber = data.coupons.normal.length
    },
    fetchUserData () {
      this.$jsonp('//mstore.gm99.com/points/user_data')
        .then((res) => {
          let data = res.data
          if (+res.result >= 1) {
            this.initData(data)
          } else {
            this.$store.commit('setTipsState', true)
            this.$store.commit('setTipsContent', res.msg)
          }
          this.$store.commit('setLoadingState', false)
        })
        .catch((err) => {
          this.$store.commit('setTipsState', true)
          this.$store.commit('setTipsContent', err.message || '系統錯誤')
        })
    }
  },
  created () {
    this.fetchUserData()
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/wallet.scss";
</style>
